import { Injectable, EventEmitter } from '@angular/core';
import { HubConnection, HubConnectionBuilder, LogLevel, HttpTransportType } from '@aspnet/signalr';
import { environment } from '../../environments/environment';
import { getAuthToken } from '../helpers/storage-helper';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class WebIdTransactionConfirmationService {
  messageReceived = new EventEmitter<any>();
  connectionEstablished = new EventEmitter<boolean>();
  private _hubConnection: HubConnection;

  constructor(private http: HttpClient) {
  }

  init(transactionId: number) {
    this.createConnection(transactionId);
    this.registerOnServerEvents();
    this.startConnection();
  }s;


  closeConnection(): void {
      this._hubConnection.stop();
  }

  private createConnection(transactionId: number) {
    this._hubConnection = new HubConnectionBuilder()
      .configureLogging(LogLevel.Error)
      .withUrl(environment.baseUrl + 'hubs/web-id-transaction-confirmation?transactionId=' + transactionId, HttpTransportType.WebSockets )
      .build();
  }

  private startConnection(): void {
    this._hubConnection
      .start()
      .then(() => {
        this.connectionEstablished.emit(true);
      })
      .catch(err => {
        setTimeout(this.startConnection, 5000);
        console.log(err);
      });
  }

  private registerOnServerEvents(): void {
    this._hubConnection.on('notify', (data: any) => {
    this.messageReceived.emit(data);
    });


    this._hubConnection.onclose ( (error?: Error) => {
      this.messageReceived.emit(error);
    });
  }
}
